export default {
    name: 'pivotTable',
    serverName: '/api/v1/reports/',
    apiUrl: '/api/v1/reports/'
};
